import { getChannelPerformanceReport } from "@/api/report-api";
import { buildCacheKey, useCollectionData } from "@/hooks/use-api";
import { ChannelPerformanceResponse } from "@/types/report-type";

export function useChannelPerformance(fromDate: string, toDate: string) {
    const cacheKey = buildCacheKey("channel-performance", { fromDate, toDate });

    return useCollectionData<ChannelPerformanceResponse>(
        cacheKey,
        () => getChannelPerformanceReport(fromDate, toDate),
        {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    );
}
